
import axios from 'axios';

const request = axios.create({
    baseURL: 'https://qy.hzzfy.com', // 你的基础URL
    timeout: 10000, // 请求超时时间
    // baseURL: 'http://localhost:8181',
    headers: {
        'Content-Type': 'application/json'
    }
});

// 请求拦截器   
request.interceptors.request.use(
    config => {
        // 在发送请求前做些什么，例如添加 token
        // console.log('发起请求:', config.url);
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
request.interceptors.response.use(


    response => {
        // 对响应数据做统一处理
        if (response.data.errcode && response.data.errcode !== 0) {
            console.error('接口业务错误:', response.data.errmsg);
            return Promise.reject(new Error(response.data.errmsg));
        }
        return response.data;
    },
    error => {
        console.error('响应错误:', error);
        return Promise.reject(error);
    }
);

export default request;
